import { useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework";

const EnterpriseWorkManagement = () => {
    const intl = useIntl();
    return (
        <TabsContent
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.planForSuccess",
                        defaultMessage: "Plan for success"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.planForSuccess.bodytext",
                        defaultMessage:
                            "Create, communicate, and organize your plans and content to make it easier for all teams to discover your org’s most important work."
                    })
                },
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.collaborateOnSharedGoals",
                        defaultMessage: "Collaborate on shared goals"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.collaborateOnSharedGoals.bodyText",
                        defaultMessage:
                            "Track and communicate your goals by sharing project status to keep everyone across your organization has visibility into work being done."
                    })
                },
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.flexYourWays",
                        defaultMessage: "Flex your ways of working"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.flexYourWays.bodyText",
                        defaultMessage:
                            "Let your teams work the way they prefer, using their own process, language, and views while still staying connected to other team’s projects."
                    })
                }
            ]}
            contentLink={{
                linkText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.learnMore",
                    defaultMessage: "Learn about work management"
                }),
                link: useLocalizedHref("/solutions/work-management"),
                linkLabel: "Learn about work management",
                productKey: "enterprise"
            }}
            pictureProps={{
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/65p0f3lsvwv2tt0v473y166n7i4147ad.webp",
                    alt: "",
                    width: 1519,
                    height: 1093
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "EnterpriseLandingPage.tab.WorkManagement.resources",
                defaultMessage: "Work management resources"
            })}
            cardsContent={[
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools",
                        defaultMessage: "Solutions"
                    }),
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools.headerText",
                        defaultMessage:
                            "Atlassian Work Management solutions and tools"
                    }),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools.linkText",
                            defaultMessage: "Learn more"
                        }),
                        href: useLocalizedHref("/solutions/work-management"),
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Learn more"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-01-solutions@2x-3900037778.webp",
                            alt: ""
                        }
                    }
                },
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt",
                        defaultMessage: "Guide"
                    }),
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt.headerText",
                        defaultMessage:
                            "A Comprehensive Guide to Work Management"
                    }),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt.linkText",
                            defaultMessage: "Get the guide"
                        }),
                        href: useLocalizedHref(
                            "/blog/work-management/guide-to-work-management-2024"
                        ),
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Get the guide"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-02-guide@2x-511342337.webp",
                            alt: ""
                        }
                    }
                },
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide",
                        defaultMessage: "Report"
                    }),
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide.headerText",
                        defaultMessage:
                            "The economic benefits of improving work management with Atlassian"
                    }),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide.linkText",
                            defaultMessage: "Read report"
                        }),
                        href: useLocalizedHref(
                            "/whitepapers/esg-work-management-report"
                        ),
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Read report"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-03-report@2x-1528241620.webp",
                            alt: ""
                        }
                    }
                }
            ]}
        />
    );
};

export { EnterpriseWorkManagement };
